// extracted by mini-css-extract-plugin
export default {"contactPageDiv":"ContactPage_contactPageDiv__4Xeew","IconArrowLeft":"ContactPage_IconArrowLeft__VYazf"};